import { White } from '@constants/color';
import { css } from '@emotion/react';

export const container = css({
  width: '1792px',
  height: '952px',
  padding: '64px'
});

export const blur = css({
  filter: 'blur(14px)'
});

export const title = css({
  fontSize: '60px',
  lineHeight: '75.12px',
  fontWeight: '700',
  color: White.White10,
  paddingTop: '32px',
  paddingBottom: '72px'
});

export const description = css({
  fontSize: '28px',
  lineHeight: '42px',
  fontWeight: '700',
  color: White.White10Alpha70,
  paddingBottom: '66px'
});
